/**
 * Created by wuyanbin on 2019/9/23
 */
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { notification } from 'antd';
const initData = {
    isCanEdit: false,
    companyName: '',
    companyLogo: '',
    selectAddressGroup: [],
    imgFileList: [],
};
export default createStore({
    state: Object.assign({}, initData),
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
        SPLICE_ARR_INDEX(state, payload) {
            state[payload.label].splice(payload.value, 1);
        },
        ADD_ARR_ITEM(state, payload) {
            state[payload.label].push(payload.value);
        },
        CHANGE_ARR_ITEM(state, payload) {
            state.imgFileList.splice(payload.index, 1, payload.value);
        }
    },
    effects: {
        resetState(params) {
            this.SET_STATE(Object.assign(Object.assign({}, initData), params));
        },
        // 获取初始化数据
        getInitData(payload, { state, update }) {
            Api.user.getTenantInfoAndArea({}).then((res) => {
                if (res) {
                    this.SET_STATE({
                        companyName: res.tenantName,
                        companyLogo: res.logoUrl,
                        selectAddressGroup: res.tenantAreaVOList,
                        imgFileList: res.tenantRoundImageVOList || []
                    });
                }
            });
        },
        // 保存数据
        saveData(payload, { state, update }) {
            const companyData = {
                tenantName: payload.companyName,
                logoUrl: state.companyLogo,
                tenantAreaQueryList: JSON.stringify(state.selectAddressGroup),
                tenantRoundImageList: JSON.stringify(state.imgFileList)
            };
            Api.user.saveTenantInfo(companyData).then((res) => {
                if (res) {
                    notification.success({ message: '保存成功' });
                    this.changeIsCanEdit({});
                }
            });
        },
        // 切换是否可以编辑
        changeIsCanEdit(payload, { state, update }) {
            update({ isCanEdit: !state.isCanEdit });
        },
        // 取消保存
        cancelEdit(payload, { state, update }) {
            this.changeIsCanEdit({});
            this.getInitData({});
        },
        // 增加地址范围
        addAddress(payload, { state, update }) {
            if (!payload.length) {
                return;
            }
            const addressType = {
                provinceName: payload[0].label,
                provinceCode: payload[0].value,
                cityName: payload[1].label,
                cityCode: payload[1].value,
            };
            // 是否存在相同的地址
            let hasRepeat = false;
            state.selectAddressGroup.map((item, index) => {
                if (item.provinceCode === addressType.provinceCode && item.cityCode === addressType.cityCode) {
                    hasRepeat = true;
                }
            });
            const params = { label: 'selectAddressGroup', value: addressType };
            hasRepeat ? notification.warning({ message: '该地址已存在' }) : this.ADD_ARR_ITEM(params);
        },
        // 删除特定的地址
        delAddressItem(payload, { state, update }) {
            const params = { label: 'selectAddressGroup', value: payload };
            this.SPLICE_ARR_INDEX(params);
        },
        // 删除图片
        delImgFun(payload, { state, update }) {
            const params = { label: 'imgFileList', value: payload };
            this.SPLICE_ARR_INDEX(params);
        },
        // 插入一个新的图片
        uploadImgFun(payload, { state, update }) {
            if (!payload) {
                return;
            }
            const params = { label: 'imgFileList', value: { imageUrl: payload, imageDefault: 0 } };
            this.ADD_ARR_ITEM(params);
        },
        // 修改默认图片
        changeDefaultImg(payload, { state, update }) {
            const currentIndex = payload.index;
            const imgFileList = state.imgFileList;
            const tempImgList = [];
            let tempItem = {};
            imgFileList.map((item, index) => {
                tempItem = Object.assign({}, item, { imageDefault: 0 });
                if (currentIndex === index) {
                    tempItem = Object.assign({}, item, { imageDefault: item.imageDefault ? 0 : 1 });
                }
                tempImgList.push(tempItem);
            });
            this.SET_STATE({ imgFileList: tempImgList });
        },
    },
});
